import { Component, OnInit, Input } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { DirectionService } from '@app/_services/direction.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import * as _ from 'lodash';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { BidiModule } from '@angular/cdk/bidi';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-block-promotion',
    templateUrl: './block-promotion.component.html',
    styleUrls: ['./block-promotion.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgClass, BidiModule, NgIf, RouterLink, MatIconModule, TranslateModule]
})
export class BlockPromotionComponent implements OnInit {
    @Input() product;
    @Input() title = '';
    @Input() caption;
    @Input() large = false;
    @Input() tagImage = 'assets/svg/promo_tag_1.svg';
    @Input() backgroundColor = '#f44541';
    @Input() foregroundColor = 'white';
    sellerLogo = '';
    image = '';
    captionArray = [
        {
            en: '',
            ar: '',
        },
        {
            en: '',
            ar: '',
        }
    ];
    discountedRate = 0;

    constructor(
        public direction: DirectionService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) {
    }

    ngOnInit(): void {
        if (this.large) {
            this.tagImage = 'assets/svg/promo_tag_2.svg';
            this.backgroundColor = '#885ef8';
        }

        try {
            let tempArrayEn = this.caption.en.split(' ');
            this.captionArray[0].en = tempArrayEn[0];
            tempArrayEn.splice(0, 1);
            this.captionArray[1].en = tempArrayEn.join(' ');
            
            let tempArrayAr = this.caption.ar.split(' ');
            this.captionArray[0].ar = tempArrayAr[0];
            tempArrayAr.splice(0, 1);
            this.captionArray[1].ar = tempArrayAr.join(' ');
        } catch (e) {
        }

        if (
            this.product?.discountValue?.value &&
            this.product?.discountValue.type != 'N'
        ) {
            let discountedPrice =
                this.product?.discountValue.type == 'F'
                    ? this.product.taxedPrice || this.product.price - this.product.discountValue?.value
                    : this.product.taxedPrice || this.product.price -
                    (this.product.discountValue?.value * this.product.taxedPrice || this.product.price) /
                    100;
            let oldPrice = this.product.baseTaxedPrice ? this.product.baseTaxedPrice : this.product.price;
            this.discountedRate = _.round((oldPrice - discountedPrice) / oldPrice * 100, 0);
        }

        try {
            this.sellerLogo = this.product?.companyData?.design?.logo.thumb?.url;
            this.image = this.product?.images[Object.keys(this.product?.images)[0]].url;
        } catch (e) {
            this.sellerLogo = '';
            this.image = '';
        }
    }

    routerLinkString() {
        return [
            `/${this.translate.currentLang}`,
            ...(this.product?.sector?.seo?.slug) ? ['sector', this.product?.sector?.seo?.slug] : '',
            this.product?.layout || this.product?.type, this.product?.seo?.slug];
    }

    getVendorLink() {
        return [
            `/${this.translate.currentLang}`,
            ...(this.product?.sector?.seo?.slug) ? ['sector', this.product?.sector?.seo?.slug] : '',
            'vendor', this.product?.companyData?.seo?.slug
        ];
    }
}
